// extracted by mini-css-extract-plugin
export var blue = "_37-g";
export var brand = "_37-c";
export var darkGrey = "_37-f";
export var disabled = "_37-6";
export var disabledSubtle = "_37-7";
export var error = "_37-8";
export var green = "_37-h";
export var grey = "_37-e";
export var icon = "_37-0";
export var inherit = "_37-b";
export var lightGrey = "_37-d";
export var orange = "_37-j";
export var pink = "_37-l";
export var primary = "_37-1";
export var purple = "_37-m";
export var quaternary = "_37-4";
export var quinary = "_37-5";
export var red = "_37-k";
export var secondary = "_37-2";
export var success = "_37-a";
export var tertiary = "_37-3";
export var warning = "_37-9";
export var white = "_37-n";
export var yellow = "_37-i";